<template>
  <div>
    <PageAllow
      controller="Presales"
      :action="savable ? 'batchSave' : 'viewByTemplate'"
    />
    <Breadcrumbs :items="items" />

    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="6" md="3">
          <v-row dense align="center" class="pa-1">
            <SearcherKeyword
              ref="keyword"
              v-model="options.keyword"
              @text="materialKeyword = $event"
              :label="$t('MaterialTemplate.priceTypes.filterHint')"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="3"> </v-col>
        <v-col cols="12" sm="6" md="3"> </v-col>
        <!-- 按钮 -->
        <v-col cols="12" sm="12" md="3" align-self="center">
          <v-row dense align="center">
            <v-spacer />
            <v-btn
              v-if="template.id && savable"
              small
              dark
              color="primary"
              @click.stop="selectMaterialsDialog = true"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.chooseInfo", [$t("Material.ObjectName")]) }}
            </v-btn>

            <v-btn
              small
              v-if="!savable"
              color="primary"
              @click="mode = 'edit'"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-pencil-alt</v-icon>
              {{ $t("CRUD.edit") }}
            </v-btn>
            <v-btn
              outlined
              small
              v-if="savable"
              color="secondary"
              @click="mode = 'view'"
              class="ms-1 elevation-1"
            >
              <v-icon x-small class="pe-1">fa-times</v-icon>
              {{ $t("CRUD.abandon") }}
            </v-btn>
            <v-btn
              small
              v-if="savable"
              color="success"
              @click="saveTemplateMaterials()"
              class="ms-1"
            >
              <v-icon x-small class="pe-1">fa-save</v-icon>
              {{ $t("CRUD.save") }}
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <v-row dense align="center" class="pa-1">
            <SearcherMaterialCategoriesWithDescendants
              v-model="categorySelecteds"
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="6" class="pt-5">
          <div
            class="caption grey--text input-chip-group-label"
            :class="$vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'"
          >
            {{ $t("Material.Fields.public_flg") }}
          </div>
          <v-chip-group
            v-model="options.public_flgs"
            column
            multiple
            class="mx-1"
          >
            <v-chip
              small
              label
              filter
              class="mx-1"
              color="primary"
              text-color="white"
              :key="1"
              :value="1"
              >{{ $t("Material.publicFlgs.on") }}</v-chip
            >
            <v-chip
              small
              label
              filter
              class="mx-1"
              color="grey"
              text-color="white"
              :key="0"
              :value="0"
              >{{ $t("Material.publicFlgs.off") }}</v-chip
            >
          </v-chip-group>
        </v-col>
      </v-row>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="template_details"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          :loading="loading"
          multi-sort
          class="elevation-1 px-4 pt-1 sticky-table"
          id="sticky-table"
          :class="
            stickTableCols
              ? settings && settings.sub_account_enable
                ? 'sticky-first-col  sticky-last-col'
                : 'sticky-first-col'
              : ''
          "
          fixed-header
          :footer-props="footerProps"
        >
          <template v-slot:body.prepend>
            <tr v-if="savable" class="d-none d-sm-table-row">
              <td></td>
              <td></td>
              <td>
                <SearcherDatetime
                  class="my-n2"
                  v-model="dateFromAll"
                  type="date"
                  single-line
                  dense
                  hide-details
                  hide-icon
                  disabledBeforeToday
                  readonly
                >
                </SearcherDatetime>
              </td>
              <td>
                <SearcherDatetime
                  class="my-n2"
                  v-model="dateToAll"
                  type="date"
                  single-line
                  dense
                  hide-details
                  hide-icon
                  disabledBeforeToday
                  readonly
                >
                </SearcherDatetime>
              </td>
              <td>
                <v-select
                  v-model="expectDateTypeAll"
                  :items="$consts.PreSell.types"
                  dense
                  hide-details
                />
              </td>
              <td>
                <v-select
                  v-if="expectDateTypeAll == 1"
                  v-model="expectDayAll"
                  :items="$consts.PreSell.days"
                  dense
                  hide-details
                />
                <SearcherDatetime
                  v-if="expectDateTypeAll == 2"
                  class="my-n2"
                  v-model="expectDateAll"
                  type="date"
                  single-line
                  dense
                  hide-details
                  hide-icon
                  :disabledBeforeToday="dateToAll ? false : true"
                  readonly
                  :disabledBeforeSpecifyTime="dateToAll ? dateToAll : ''"
                >
                </SearcherDatetime>
              </td>
              <td>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="numAll"
                  type="number"
                  min="0"
                  @blur="
                    numAll = $numberFormatter.formatWithDotNoMoreThan(numAll, 2)
                  "
                  style="max-width: 100px; margin-left: auto"
                />
              </td>
              <td>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="confineNumAll"
                  type="number"
                  min="0"
                  @blur="
                    confineNumAll = $numberFormatter.formatWithDotNoMoreThan(
                      confineNumAll,
                      2
                    )
                  "
                  style="max-width: 100px; margin-left: auto"
                />
              </td>
              <td></td>
              <td>
                <v-select
                  dense
                  hide-details
                  placeholder="-"
                  style="
                    max-width: 140px;
                    margin-left: auto;
                    margin-right: auto;
                  "
                  :items="unitSettingSelect"
                  item-text="text"
                  item-value="value"
                  clearable
                  v-model="unitSettingAll"
                />
              </td>
              <td>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="multipleAll"
                  type="number"
                  min="0"
                  @blur="
                    multipleAll = $numberFormatter.formatWithDotNoMoreThan(
                      multipleAll,
                      2
                    )
                  "
                  style="max-width: 100px; margin-left: auto"
                />
              </td>
              <td>
                <v-text-field
                  single-line
                  dense
                  hide-details
                  v-model="minNumAll"
                  type="number"
                  min="0"
                  @blur="
                    minNumAll = $numberFormatter.formatWithDotNoMoreThan(
                      minNumAll,
                      2
                    )
                  "
                  style="max-width: 100px; margin-left: auto"
                />
              </td>

              <td class="align-center">
                <v-checkbox
                  class="mt-2 mb-n2"
                  color="primary"
                  :indeterminate="
                    template_details.find((detail) => detail.valid != validAll)
                      ? true
                      : false
                  "
                  v-model="validAll"
                  :true-value="1"
                  :false-value="0"
                >
                  <template v-slot:label>
                    <span class="caption ms-n2">
                      {{ $t("MaterialTemplate.thisPage")
                      }}{{ $t("MaterialTemplate.valid_all") }}
                    </span>
                  </template>
                </v-checkbox>
              </td>
              <td
                v-if="
                  settings &&
                  settings.sub_account_enable &&
                  settings.sub_account_enable != 2
                "
              ></td>

              <td v-if="settings && settings.service_charge_enable">
                <v-text-field
                  v-if="savable"
                  single-line
                  dense
                  hide-details
                  v-model="serviceChargePercentAll"
                  type="number"
                  min="0"
                  suffix="%"
                  @blur="
                    serviceChargePercentAll =
                      $numberFormatter.formatWithDotNoMoreThan(
                        serviceChargePercentAll,
                        2
                      )
                  "
                  style="max-width: 100px; margin-left: auto"
                />
              </td>
            </tr>
            <tr v-if="savable" class="d-table-row d-sm-none">
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("PreSell.DetailFieds.date_from") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <SearcherDatetime
                    class="my-n2"
                    v-model="dateFromAll"
                    type="date"
                    single-line
                    dense
                    hide-details
                    hide-icon
                    disabledBeforeToday
                    readonly
                  >
                  </SearcherDatetime>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("PreSell.DetailFieds.date_to") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <SearcherDatetime
                    class="my-n2"
                    v-model="dateToAll"
                    type="date"
                    single-line
                    dense
                    hide-details
                    hide-icon
                    disabledBeforeToday
                    readonly
                  >
                  </SearcherDatetime>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("PreSell.expect_date_type.obj") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-select
                    v-model="expectDateTypeAll"
                    :items="$consts.PreSell.types"
                    dense
                    hide-details
                  />
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("PreSell.expect_day.obj") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-select
                    v-if="expectDateTypeAll == 1"
                    v-model="expectDayAll"
                    :items="$consts.PreSell.days"
                    dense
                    hide-details
                  />
                  <SearcherDatetime
                    v-if="expectDateTypeAll == 2"
                    class="my-n2"
                    v-model="expectDateAll"
                    type="date"
                    single-line
                    dense
                    hide-details
                    hide-icon
                    :disabledBeforeToday="dateToAll ? false : true"
                    readonly
                    :disabledBeforeSpecifyTime="dateToAll ? dateToAll : ''"
                  >
                  </SearcherDatetime>
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("PreSell.DetailFieds.num") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="numAll"
                    type="number"
                    min="0"
                    @blur="
                      numAll = $numberFormatter.formatWithDotNoMoreThan(
                        numAll,
                        2
                      )
                    "
                    style="max-width: 100px; margin-left: auto"
                  />
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("PreSell.DetailFieds.confine_num") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="confineNumAll"
                    type="number"
                    min="0"
                    @blur="
                      confineNumAll = $numberFormatter.formatWithDotNoMoreThan(
                        confineNumAll,
                        2
                      )
                    "
                    style="max-width: 100px; margin-left: auto"
                  />
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.unit") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-select
                    dense
                    hide-details
                    placeholder="-"
                    style="
                      max-width: 140px;
                      margin-left: auto;
                      margin-right: auto;
                    "
                    :items="unitSettingSelect"
                    item-text="text"
                    item-value="value"
                    clearable
                    v-model="unitSettingAll"
                  />
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.multiple") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="multipleAll"
                    type="number"
                    min="0"
                    @blur="
                      multipleAll = $numberFormatter.formatWithDotNoMoreThan(
                        multipleAll,
                        2
                      )
                    "
                    style="max-width: 100px; margin-left: auto"
                  />
                </div>
              </td>
              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.min_num") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-text-field
                    single-line
                    dense
                    hide-details
                    v-model="minNumAll"
                    type="number"
                    min="0"
                    @blur="
                      minNumAll = $numberFormatter.formatWithDotNoMoreThan(
                        minNumAll,
                        2
                      )
                    "
                    style="max-width: 100px; margin-left: auto"
                  />
                </div>
              </td>

              <td class="v-data-table__mobile-row">
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("Material.templates.usable") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-checkbox
                    class="mt-2 mb-n2"
                    color="primary"
                    :indeterminate="
                      template_details.find(
                        (detail) => detail.valid != validAll
                      )
                        ? true
                        : false
                    "
                    v-model="validAll"
                    :label="$t('MaterialTemplate.valid_all')"
                  ></v-checkbox>
                </div>
              </td>
              <td
                class="v-data-table__mobile-row"
                v-if="settings && settings.service_charge_enable"
              >
                <div class="v-data-table__mobile-row__header mt-1">
                  {{ $t("MaterialTemplate.Fields.service_charge_percent") }}
                </div>
                <div class="v-data-table__mobile-row__cell mt-1">
                  <v-text-field
                    v-if="savable"
                    single-line
                    dense
                    hide-details
                    v-model="serviceChargePercentAll"
                    type="number"
                    min="0"
                    suffix="%"
                    @blur="
                      serviceChargePercentAll =
                        $numberFormatter.formatWithDotNoMoreThan(
                          serviceChargePercentAll,
                          2
                        )
                    "
                    style="max-width: 100px; margin-left: auto"
                  />
                </div>
              </td>
            </tr>
          </template>

          <template v-slot:header.split_price="{ header }">
            <span v-if="settings && settings.sub_account_split_type">
              {{ $t("MaterialTemplate.splitPrices.percent") }}
            </span>
            <span v-else>
              {{ header.text }}
            </span>
          </template>

          <template v-slot:item.Description="{ item, index }">
            <span :v-resize="!index ? $stickTableResizer() : null"> </span>
            <div class="d-inline-block ma-1">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    class="d-block text-truncate"
                    style="max-width: 430px; cursor: pointer"
                    >{{ item.material_name }}
                  </span>
                </template>
                {{ item.material_name }}
              </v-tooltip>
              <span class="caption secondary--text">
                {{ item.material_code }}
              </span>
            </div>
          </template>
          <template v-slot:item.date_from="{ item }">
            <div v-if="savable">
              <SearcherDatetime
                class="my-n2"
                v-model="item.date_from"
                type="date"
                single-line
                dense
                hide-details
                hide-icon
                disabledBeforeToday
                required
                readonly
              >
                <template v-slot:message="{ key, message }">
                  <div :class="key == 0 ? 'danger--text' : ''">
                    {{ message }}
                  </div>
                </template>
              </SearcherDatetime>
            </div>
            <span v-else>
              {{ item.date_from | formatDate }}
            </span>
          </template>
          <template v-slot:item.date_to="{ item }">
            <div v-if="savable">
              <SearcherDatetime
                class="my-n2"
                v-model="item.date_to"
                type="date"
                single-line
                dense
                hide-details
                hide-icon
                disabledBeforeToday
                required
                readonly
              >
                <template v-slot:message="{ key, message }">
                  <div :class="key == 0 ? 'danger--text' : ''">
                    {{ message }}
                  </div>
                </template>
              </SearcherDatetime>
            </div>
            <span v-else>
              {{ item.date_to | formatDate }}
            </span>
          </template>
          <template v-slot:item.expect_date_type="{ item }">
            <div v-if="savable">
              <v-select
                v-model="item.expect_date_type"
                :items="$consts.PreSell.types"
                dense
                hide-details
              />
            </div>
            <span v-else>
              {{ item.expect_date_type | expectDateTypeText }}
            </span>
          </template>
          <template v-slot:item.expect_day="{ item }">
            <div v-if="savable">
              <v-select
                v-if="item.expect_date_type == 1"
                v-model="item.expect_day"
                :items="$consts.PreSell.days"
                dense
                hide-details
              />
              <SearcherDatetime
                v-if="item.expect_date_type == 2"
                class="my-n2"
                v-model="item.expect_date"
                type="date"
                single-line
                dense
                hide-details
                hide-icon
                :disabledBeforeToday="item.date_to ? false : true"
                required
                readonly
                :disabledBeforeSpecifyTime="item.date_to ? item.date_to : ''"
              >
                <!-- <template v-slot:message="{ key, message }">
                  <div :class="key == 0 ? 'danger--text' : ''">
                    {{ message }}
                  </div>
                </template> -->
              </SearcherDatetime>
            </div>
            <span v-else>
              <span v-if="item.expect_date_type == 1">
                {{ item.expect_day | expectDaysText }}
              </span>
              <span v-if="item.expect_date_type == 2">
                {{ item.expect_date | formatDate }}
              </span>
            </span>
          </template>
<!--          <template v-slot:item.standard="{ item }">-->
<!--            <span v-if="template && template.id">-->
<!--              {{ item.standard_name }}-->
<!--            </span>-->
<!--            <span v-else>-->
<!--              <v-text-field-->
<!--                single-line-->
<!--                v-if="item && item.standard && savable"-->
<!--                v-model="item.standard.name"-->
<!--              />-->
<!--              <span v-else>-->
<!--                {{ item && item.standard ? item.standard.name : "" }}-->
<!--              </span>-->
<!--            </span>-->
<!--          </template>-->
          <template v-slot:item.supply_price="{ item }">
            <div v-if="savable">
              <v-text-field
                single-line
                dense
                hide-details
                v-model="item.supply_price"
                type="number"
                min="0"
                :prefix="$t('Global.money')"
                @blur="
                  item.supply_price = $numberFormatter.formatWithDotNoMoreThan(
                    item.supply_price,
                    2
                  )
                "
                style="max-width: 100px; margin-left: auto"
              />
            </div>
            <span v-else>
              {{ $t("Global.money") }}{{ item.supply_price }}
            </span>
          </template>

          <template v-slot:item.unit="{ item }">
            <div v-if="savable">
              <v-select
                single-line
                dense
                hide-details
                style="max-width: 60px; margin-right: auto; margin-left: auto"
                :items="item.standard_details"
                item-text="unit"
                item-value="id"
                v-model="item.standard_detail_id"
              />
              <div
                v-if="
                  item.select_standard_detail &&
                  item.select_standard_detail.rate > 1
                "
                class="mt-n5"
              >
                <br />
                <span class="caption secondary--text">
                  (1{{ item.select_standard_detail.unit }}={{
                    item.select_standard_detail.rate
                  }}{{ item.default_unit }})
                </span>
              </div>
            </div>
            <span v-else>
              {{ item.unit }}
            </span>
          </template>
          <template v-slot:item.num="{ item }">
            <div v-if="savable">
              <v-text-field
                single-line
                dense
                hide-details
                v-model="item.num"
                type="number"
                min="0"
                class="input-center"
                @blur="
                  item.num = $numberFormatter.formatWithDotNoMoreThan(
                    item.num,
                    2
                  )
                "
                style="max-width: 60px; margin-left: auto"
              />
            </div>
            <span v-else>
              {{ item.num | formatTwoDot }}
            </span>
          </template>
          <template v-slot:item.confine_num="{ item }">
            <div v-if="savable">
              <v-text-field
                single-line
                dense
                hide-details
                v-model="item.confine_num"
                type="number"
                min="0"
                class="input-center"
                @blur="
                  item.confine_num = $numberFormatter.formatWithDotNoMoreThan(
                    item.confine_num,
                    2
                  )
                "
                style="max-width: 60px; margin-left: auto"
              />
            </div>
            <span v-else>
              {{ item.confine_num | formatTwoDot }}
            </span>
          </template>
          <template v-slot:item.multiple="{ item }">
            <div v-if="savable">
              <v-text-field
                single-line
                dense
                hide-details
                v-model="item.multiple"
                type="number"
                min="0"
                class="input-center"
                @blur="
                  item.multiple = $numberFormatter.formatWithDotNoMoreThan(
                    item.multiple,
                    2
                  )
                "
                style="max-width: 60px; margin-left: auto"
              />
            </div>
            <span v-else>
              {{ item.multiple | formatTwoDot }}
            </span>
          </template>
          <template v-slot:item.min_num="{ item }">
            <div v-if="savable">
              <v-text-field
                single-line
                dense
                hide-details
                v-model="item.min_num"
                type="number"
                min="0"
                class="input-center"
                @blur="
                  item.min_num = $numberFormatter.formatWithDotNoMoreThan(
                    item.min_num,
                    2
                  )
                "
                style="max-width: 60px; margin-left: auto"
              />
            </div>
            <span v-else>
              {{ item.min_num | formatTwoDot }}
            </span>
          </template>
          <template v-slot:item.valid="{ item }">
            <div class="d-flex mt-n2 mb-n3">
              <v-checkbox
                color="primary"
                v-model="item.valid"
                :true-value="1"
                :false-value="0"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.valid
                          ? "Material.templates.usable_on"
                          : "Material.templates.usable_off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
          </template>
          <template v-slot:item.public_flg="{ item }">
            <div class="d-flex mt-n2 mb-n3" v-if="savable">
              <v-checkbox
                color="primary"
                v-model="item.public_flg"
                :true-value="1"
                :false-value="0"
              >
                <template v-slot:label>
                  <span class="caption ms-n2">
                    {{
                      $t(
                        item.public_flg
                          ? "Material.publicFlgs.on"
                          : "Material.publicFlgs.off"
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </div>
            <span class="caption ms-n2" v-else>
              {{
                $t(
                  item.public_flg
                    ? "Material.publicFlgs.on"
                    : "Material.publicFlgs.off"
                )
              }}
            </span>
          </template>
          <template v-slot:item.split_price="{ item }">
            <v-btn small text color="info" @click="splitPriceItem = item">
              {{ $t("Opt.details") }}
            </v-btn>
          </template>
          <template v-slot:item.service_charge_percent="{ item }">
            <v-text-field
              v-if="savable"
              single-line
              dense
              hide-details
              v-model="item.service_charge_percent"
              type="number"
              min="0"
              suffix="%"
              @blur="
                item.service_charge_percent =
                  $numberFormatter.formatWithDotNoMoreThan(
                    item.service_charge_percent,
                    2
                  )
              "
              style="max-width: 100px; margin-left: auto"
            />
            <span v-else> {{ item.service_charge_percent }} % </span>
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <LastPrice v-model="lastPriceFor" />
    <SplitPrice
      v-model="splitPriceItem"
      :mode="mode"
      :bank_code="template.sub_account_pay_type"
      :price="splitPriceItem ? Number(splitPriceItem.supply_price) : 0"
      percent
    />
    <SelectTemplateMaterials
      v-model="selectMaterialsDialog"
      :changed="changedDetails"
      @confirm="
        changedDetails = $event;
        if (options.page == 1) getpresalesFromAPI();
        else options.page = 1;
      "
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherMaterialCategoriesWithDescendants from "@/components/plugins/SearcherMaterialCategoriesWithDescendants";
import LastPrice from "@/components/templates/plugins/LastPrice";
import SplitPrice from "@/components/templates/plugins/SplitPrice";
import SelectTemplateMaterials from "./plugins/SelectAllTemplateMaterials";
import PresaleTemplates from "@/api/presale_templates";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    SearcherMaterialCategoriesWithDescendants,
    LastPrice,
    SplitPrice,
    SelectTemplateMaterials,
    SearcherDatetime,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new" || this.mode == "clone";
    },
    isNew() {
      return this.mode == "new" || this.mode == "clone";
    },
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.materialManagement"),
          disabled: false,
          href: "/materials",
        },
        {
          text: i18n.t("Nav.PreSell"),
          disabled: false,
          href: "/pre-sell",
        },
        {
          text: this.savable
            ? i18n.t("Nav.materialTemplatePriceSet")
            : i18n.t("Nav.materialTemplateDetail"),
          disabled: true,
        },
        {
          text:
            this.template && this.template.template_name
              ? this.template.template_name
              : i18n.t("Nav.materialTemplateDetail"),
          disabled: false,
          accent: true,
        },
      ];
    },
    headers() {
      var headers = [
        {
          text: i18n.t("MaterialTemplate.Fields.material"),
          align: "start",
          sortable: false,
          filterable: true,
          value: "Description",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.material_category"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          filterable: true,
          value: "category_name",
        },
        {
          text: i18n.t("PreSell.DetailFieds.date_from"),
          align: "end",
          sortable: false,
          filterable: false,
          class: "text-no-wrap",
          value: "date_from",
          width: 120,
        },
        {
          text: i18n.t("PreSell.DetailFieds.date_to"),
          align: "end",
          sortable: false,
          filterable: false,
          class: "text-no-wrap",
          value: "date_to",
          width: 120,
        },
        {
          text: i18n.t("PreSell.expect_date_type.obj"),
          align: "end",
          sortable: false,
          filterable: false,
          value: "expect_date_type",
        },
        {
          text: i18n.t("PreSell.expect_day.obj"),
          align: "end",
          sortable: false,
          filterable: false,
          value: "expect_day",
          width: 120,
        },
        {
          text: i18n.t("PreSell.DetailFieds.num"),
          align: "end",
          sortable: false,
          filterable: false,
          value: "num",
        },
        {
          text: i18n.t("PreSell.DetailFieds.confine_num"),
          align: "end",
          sortable: false,
          filterable: false,
          value: "confine_num",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.supply_price"),
          align: "end",
          sortable: false,
          filterable: false,
          value: "supply_price",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.unit"),
          align: "center",
          sortable: false,
          filterable: true,
          value: "unit",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.multiple"),
          align: "end",
          sortable: false,
          filterable: true,
          value: "multiple",
        },
        {
          text: i18n.t("MaterialTemplate.Fields.min_num"),
          align: "end",
          sortable: false,
          filterable: true,
          value: "min_num",
        },
      ];

      if (this.settings && this.settings.sub_account_enable) {
        if (this.savable) {
          headers.push({
            text: i18n.t("Material.templates.usable"),
            align: "start",
            sortable: false,
            filterable: false,
            value: "valid",
          });
        }
        if (this.settings && this.settings.sub_account_enable != 2) {
          headers.push({
            text: i18n.t("MaterialTemplate.Fields.split_price"),
            align: "center",
            sortable: false,
            filterable: false,
            value: "split_price",
          });
        }
      } else if (this.savable) {
        headers.push({
          text: i18n.t("Material.templates.usable"),
          align: "start",
          sortable: false,
          filterable: false,
          value: "valid",
        });
      }
      if (this.settings && this.settings.service_charge_enable) {
        headers.push({
          text: i18n.t("MaterialTemplate.Fields.service_charge_percent"),
          align: "center",
          sortable: false,
          filterable: false,
          value: "service_charge_percent",
        });
      }
      return headers;
    },

    unitSettingSelect: () => [
      {
        value: 1,
        text: i18n.t("MaterialTemplate.unitSettings.defaultUnitAll"),
      },
      { value: 2, text: i18n.t("MaterialTemplate.unitSettings.maxUnitAll") },
    ],
    footerProps() {
      var props = Object.assign({}, i18n.t("$config.footer-props"));
      props.itemsPerPageOptions = [...props.itemsPerPageOptions, -1];
      return props;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings", "stickTableCols", "accountInfo"]),
  },

  mounted() {
    this.mode = this.$route.params.mode;
    // if (this.mode) this.$router.replace("/templates/" + this.$route.params.id);
  },

  data: () => ({
    mode: "",
    materialKeyword: "",
    categorySelecteds: [],
    options: {
      keyword: "",
      category_ids: [],
      readonly: 1,
      status: [1], // 只获取生效的
      page: 1,
      sortBy: [],
      sortDesc: [],
      public_flgs: [1],
    },
    paging: {},
    priceTypeCount: [],
    unitSettingAll: 0,
    multipleAll: "",
    minNumAll: "",
    dateFromAll: "",
    dateToAll: "",
    expectDateTypeAll: "",
    expectDayAll: "",
    expectDateAll: "",
    numAll: "",
    confineNumAll: "",
    serviceChargePercentAll: "",
    validAll: 1,
    template: {},
    template_details: [],
    changedDetails: [],
    lastPriceFor: null,
    selectMaterialsDialog: false,
    splitPriceItem: null,
  }),

  methods: {
    getpresalesFromAPI() {
      if (this.savable) this.$store.dispatch("fullscreenLoading");
      PresaleTemplates.fetchPresales(
        this.$route.params.id,
        Object.assign({}, this.options, {
          unsaved: this.changedDetails
            .filter((d) => !d.status)
            .map((d) => d.id),
        })
      )
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.template = response.data.template;
              this.template_details = response.data.template_details.map(
                (item) => {
                  var changedDetail = this.changedDetails.find(
                    (s) => this.template.id && s.id == item.id
                  );
                  if (changedDetail) return changedDetail;
                  item.multiple = Number(item.multiple);
                  item.min_num = Number(item.min_num);
                  item.valid = item.status;
                  item.standard_details = item.standard_details
                    ? item.standard_details
                    : [];
                  return item;
                }
              );
              this.paging = response.data.paging;
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(
          function () {
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
    },
    saveTemplateMaterials() {
      this.$store.dispatch("fullscreenLoading");
      var data = this.changedDetails
        .filter(
          (detail) =>
            detail.valid || // 非默认模板保存生效的商品
            detail.status != detail.valid // 以及生效状态改变的商品
        )
        .map(
          function (detail) {
            let detailData = {
              id: detail.id,
              material_id: detail.material_id,
              date_from: detail.date_from,
              date_to: detail.date_to,
              expect_date_type: detail.expect_date_type,
              expect_day: detail.expect_date_type == 1 ? detail.expect_day : "",
              expect_date:
                detail.expect_date_type == 2 ? detail.expect_date : "",
              num: detail.num,
              confine_num: detail.confine_num,
              min_num: detail.min_num,
              multiple: detail.multiple,
              supply_price: detail.supply_price,
              status: detail.valid,
              standard_detail_id: detail.standard_detail_id,
              sub_account_price_json: detail.sub_account_price_json,
            };
            if (this.settings && this.settings.service_charge_enable) {
              detailData.service_charge_percent = detail.service_charge_percent;
            }
            return detailData;
          }.bind(this)
        );
      PresaleTemplates.batchSave(data)
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.mode = "view";
              this.options.page = 1;
            }
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        )
        .catch(function () {
          this.$store.dispatch("fullscreenLoadingStop");
        });
    },
  },

  watch: {
    mode: {
      handler() {
        if (this.isView) {
          this.materialKeyword = "";
          this.categorySelecteds = [];
          this.changedDetails = [];
          this.validAll = 1;
          this.options.readonly = 1;
        } else {
          this.options.readonly = 0;
        }
        this.changedDetails = []; // 模式变化时清空已编辑数组
      },
    },
    categorySelecteds: {
      handler() {
        this.options.category_ids = this.categorySelecteds.map(
          (category) => category.id
        );
      },
    },
    options: {
      deep: true,
      handler() {
        this.getpresalesFromAPI();
      },
    },

    unitSettingAll: {
      handler() {
        if (this.unitSettingAll == 1) {
          this.template_details = this.template_details.map((detail) => {
            if (detail.is_follow) {
              detail.material.supply_standard_detail_id =
                detail.standard_details.find((s) => s.default_flg == 1)
                  ? detail.standard_details.find((s) => s.default_flg == 1).id
                  : "";
            } else {
              detail.standard_detail_id = detail.standard_details.find(
                (s) => s.default_flg == 1
              )
                ? detail.standard_details.find((s) => s.default_flg == 1).id
                : "";
            }

            return detail;
          });
        } else if (this.unitSettingAll == 2) {
          this.template_details = this.template_details.map((detail) => {
            if (detail.is_follow) {
              detail.material.supply_standard_detail_id =
                detail.standard_details.find((s) => s.max_unit_flg == 1)
                  ? detail.standard_details.find((s) => s.max_unit_flg == 1).id
                  : "";
            } else {
              detail.standard_detail_id = detail.standard_details.find(
                (s) => s.max_unit_flg == 1
              )
                ? detail.standard_details.find((s) => s.max_unit_flg == 1).id
                : "";
            }

            return detail;
          });
        }
      },
    },
    multipleAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.multiple = this.multipleAll;
            return detail;
          }.bind(this)
        );
      },
    },
    minNumAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.min_num = this.minNumAll;
            return detail;
          }.bind(this)
        );
      },
    },
    numAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.num = this.numAll;
            return detail;
          }.bind(this)
        );
      },
    },
    confineNumAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.confine_num = this.confineNumAll;
            return detail;
          }.bind(this)
        );
      },
    },
    dateFromAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.date_from = this.dateFromAll;
            return detail;
          }.bind(this)
        );
      },
    },
    dateToAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.date_to = this.dateToAll;
            return detail;
          }.bind(this)
        );
      },
    },
    expectDateTypeAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.expect_date_type = this.expectDateTypeAll;
            return detail;
          }.bind(this)
        );
      },
    },
    expectDayAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.expect_day = this.expectDayAll;
            return detail;
          }.bind(this)
        );
      },
    },
    expectDateAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.expect_date = this.expectDateAll;
            return detail;
          }.bind(this)
        );
      },
    },
    validAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.valid = this.validAll ? 1 : 0;
            return detail;
          }.bind(this)
        );
      },
    },
    serviceChargePercentAll: {
      handler() {
        this.template_details = this.template_details.map(
          function (detail) {
            detail.service_charge_percent = this.serviceChargePercentAll;
            return detail;
          }.bind(this)
        );
      },
    },
    template_details: {
      deep: true,
      handler() {
        this.template_details.forEach((detail) => {
          if (!this.options.readonly) {
            // 编辑模式下添加到已修改数组里
            if (detail.valid || detail.valid != detail.status) {
              var changedDetail = this.changedDetails.find(
                (s) => this.template.id && s.id == detail.id
              );
              if (!changedDetail) this.changedDetails.push(detail);
            }
          }
          detail.select_standard_detail = detail.standard_details
            ? detail.standard_details.find(
                (s) => s.id == detail.standard_detail_id
              )
            : null;
        }); // 不管是新改变的还是原先就是有效状态的，都添加到changedDetails数组中
      },
    },
  },

  beforeDestroy() {
    this.$store.dispatch("threadLoadingStopAll");
  },
};
</script>